import React from 'react'
import { FormControlLabel, Grid, styled, Checkbox as MuiCheckbox } from '@mui/material'
import { FieldRenderProps } from 'react-final-form'
import styles from '../../styles'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	textFieldStyle: {
		boxSizing: 'border-box'
	},
	errorStyle: {
		color: '#B92D00',
		fontSize: 10
	},
	errorColor: {
		color: '#B92D00 !important'
	},
	errorBorder: {
		border: '1px solid #B92D00'
	},
	rootForm: {
		marginRight: 0
	}
}))

const CustomCheckBox = styled(MuiCheckbox)(({ theme }) => ({
	root: {
		color: theme.palette.blue['60'],
		'&$checked': {
			color: theme.palette.accessibility.main
		}
	},
	checked: {}
}))

interface AcceptingProps {
	name: string,
	label: string,
	color: string,
	textStyle: string,
	disabled?: boolean
}

type CheckBoxFieldProps = FieldRenderProps<boolean> & AcceptingProps

const CheckBoxField: React.FC<CheckBoxFieldProps> = (
	{
		input,
		meta: {
			touched,
			error
		},
		label,
		color,
		textStyle,
		name,
		disabled = false
	}
) => {
	const { classes, cx } = useStyles()

	const checkboxFieldClass = cx(
		classes.textFieldStyle,
		{
			[classes.errorBorder]: touched && error
		}
	)

	const checkBoxClass = cx(
		classes[color as keyof typeof styles],
		classes[textStyle as keyof typeof styles]
	)

	return (
		<Grid container item xs={12}>
			<div className={checkboxFieldClass}>
				<FormControlLabel
					key={`checkbox-${name}`}
					control={
						<CustomCheckBox {...input} />
					}
					label={label}
					disabled={disabled}
					classes={{
						root: classes.rootForm,
						label: checkBoxClass
					}}
				/>
			</div>

			{
				touched &&
				((error && <span className={classes.errorStyle}>{error}</span>))
			}
		</Grid>
	)
}

export default CheckBoxField
